import React from 'react';
import { styled } from '@linaria/react';
import { ColorPath } from 'types/Theme';
import { cssTheme } from '../../../themes';
import { getCssColorByPath } from '../../../utils/colors';
interface Props {
  /** Specify the color path from the theme's colors file to explicitly set the Spinner's color */
  colorPath?: ColorPath;
  size?: number;
  /** Pass through classname to allow styles overrides */
  className?: string;
}
interface StyleProps {
  color?: string;
  size: number;
}
const _exp2 = /*#__PURE__*/() => ({
  size
}) => size;
const SpinnerWrapper = /*#__PURE__*/styled('div')({
  name: "SpinnerWrapper",
  class: "s1iq9iwv",
  propsAsIs: false,
  vars: {
    "s1iq9iwv-0": [_exp2(), "px"]
  }
});
const _exp5 = /*#__PURE__*/() => ({
  size
}) => `translate(-${size / 2}px, -${size / 2}px) scale(${size * 0.005})
    translate(${size / 2}px, ${size / 2}px)`;
const _exp6 = /*#__PURE__*/() => ({
  size
}) => size;
const _exp7 = /*#__PURE__*/() => ({
  color
}) => color || cssTheme.colors.background.brand.c400;
export const SpinnerElement = /*#__PURE__*/styled('div')({
  name: "SpinnerElement",
  class: "sx9rup9",
  propsAsIs: false,
  vars: {
    "sx9rup9-0": [_exp6(), "px"],
    "sx9rup9-1": [_exp5()],
    "sx9rup9-2": [_exp7()]
  }
});
export const AnimatedCircle = /*#__PURE__*/styled('div')({
  name: "AnimatedCircle",
  class: "a5mg9fp",
  propsAsIs: false
});
export const Spinner = ({
  colorPath,
  size = 24,
  className
}: Props) => {
  const color = colorPath && getCssColorByPath(colorPath);
  return <SpinnerWrapper size={size} className={className}>
      <SpinnerElement color={color} size={size}>
        {[...Array(8).keys()].map((value: number) => <AnimatedCircle key={value}>
            <div className="spinner-circle" />
          </AnimatedCircle>)}
      </SpinnerElement>
    </SpinnerWrapper>;
};

require("./Spinner.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Spinner.tsx");